import React, { useCallback, useEffect, useState } from 'react';
import { Space, Tag, Button } from 'antd';
import { Link } from 'react-router-dom';
import adminProductService from '../../services/adminProductService';
import AdminSubscriptionEditModal from './AdminSubscriptionEditModal';
import { STATUS_COLOR, STATUS_LABEL } from './adminProductMeta';
import { adminPath } from '../../../shared/config/paths';

/** 后台资源页顶部一行：所属用户 · 套餐 · 到期 · 自动续费 ·「套餐 / 到期」编辑。 */
const AdminResourcePlanBar = ({ type, id, style }) => {
    const [info, setInfo] = useState(null);
    const [open, setOpen] = useState(false);
    const load = useCallback(async () => {
        if (!id) return;
        const r = await adminProductService.byResource(type, id);
        if (r?.success) setInfo(r.data);
    }, [type, id]);
    useEffect(() => { load(); }, [load]);
    if (!info) return null;
    const s = info.subscription;
    return (
        <Space wrap size={8} style={{ marginBottom: 12, ...style }}>
            <Link to={adminPath(`/users/${info.user_id}`)}>用户 #{info.user_id}</Link>
            {s ? (
                <>
                    <Link to={adminPath(`/billing/subscriptions?id=${s.id}`)}>{s.product_name || `#${s.product_id}`}</Link>
                    <Tag color={STATUS_COLOR[s.status] || 'default'}>{STATUS_LABEL[s.status] || s.status}</Tag>
                    <span>到期 {s.expiry_date ? String(s.expiry_date).slice(0, 10) : '不过期'}</span>
                    <Tag>{s.auto_renew ? '自动续费' : '不自动续费'}</Tag>
                    {!['cancelled', 'terminated'].includes(s.status) && <Button size="small" onClick={() => setOpen(true)}>套餐 / 到期</Button>}
                    <AdminSubscriptionEditModal open={open} subscriptionId={s.id} onClose={() => setOpen(false)} onSaved={load} />
                </>
            ) : <Tag>无套餐</Tag>}
        </Space>
    );
};

export default AdminResourcePlanBar;
